import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Help from './containers/Help';

const MainRouter = () => (
  <BrowserRouter>
    <Switch>
      <Route path="/help" component={Help} />
    </Switch>
  </BrowserRouter>
)

export default MainRouter